module.exports = __webpack_public_path__ + "media/Video 46.7402deba.mp4";